export default () => {
  if (!global.TIMEOUT_AFTER_MINUTES) {
    throw new Error('TIMEOUT_AFTER_MINUTES is not specified');
  }
  if (!global.TIMEOUT_WARNING_AFTER_MINUTES) {
    throw new Error('TIMEOUT_WARNING_AFTER_MINUTES is not specified');
  }
  return {
    timeoutAfterMinutes: global.TIMEOUT_AFTER_MINUTES,
    timeoutWarningAfterMinutes: global.TIMEOUT_WARNING_AFTER_MINUTES,
  };
};
